import { render, staticRenderFns } from "./CategoryGroups.vue?vue&type=template&id=b1e50c9a&"
import script from "./CategoryGroups.vue?vue&type=script&lang=js&"
export * from "./CategoryGroups.vue?vue&type=script&lang=js&"
import style0 from "./CategoryGroups.vue?vue&type=style&index=0&id=b1e50c9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports